import { atom, useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'

type ContentState =  {
  type: 'help' | 'introduction' | 'notic' | string&{}
  content: string
}[]

const contentState = atom<ContentState>({
  key: 'contentState',
  default: []
})

export const useContentState = ()=>useRecoilState(contentState)
export const useContentValue = ()=>useRecoilValue(contentState)
export const useSetContentState = ()=>useSetRecoilState(contentState)
